import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import InvoiceItem from '../InvoiceItem';
import DataList from '@afosto/app-components-react/DataList';
import Pagination from '@afosto/app-components-react/Pagination';
import translations from './translations';

const DataListGridContainer = props => <Grid container spacing={1} {...props} />;

const ItemsList = ({ dataSource, isVatShifted, isIncludingVat }) => {
  const intl = useIntl();
  const { data, pagination: paginationModule = {} } = dataSource;
  const {
    activePage,
    getNextPageCursor,
    goToPage,
    itemCount,
    itemsPerPage = 10,
    itemsPerPageOptions,
    setItemsPerPage,
  } = paginationModule;

  /**
   * Handle the change page event. Sets the active page.
   * @param {Object} event
   * @param {number} page
   */
  const handleChangePage = (event, page) => {
    goToPage(page);
  };

  /**
   * Handle the change rows per page event. Sets the rows per page.
   * @param {number} event
   */
  const handleChangeRowsPerPage = event => {
    setItemsPerPage(parseInt(event.target.value, 10));
  };

  const renderItem = item => (
    <Grid key={item?.reference} item xs={12}>
      <InvoiceItem item={item} isVatShifted={isVatShifted} isIncludingVat={isIncludingVat} />
    </Grid>
  );

  return (
    <>
      <Card style={{ marginBottom: 8 }}>
        <DataList
          dataSource={dataSource}
          renderItem={renderItem}
          component={DataListGridContainer}
          emptyMessage={intl.formatMessage(translations.emptyMessage)}
          viewPagination={false}
        />
      </Card>
      {data?.length > 0 && (
        <Pagination
          getNextPageCursor={getNextPageCursor}
          itemCount={itemCount}
          itemsPerPage={itemsPerPage}
          itemsPerPageOptions={itemsPerPageOptions}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          page={activePage}
        />
      )}
    </>
  );
};

ItemsList.propTypes = {
  dataSource: PropTypes.object,
  isIncludingVat: PropTypes.bool,
  isVatShifted: PropTypes.bool,
};

ItemsList.defaultProps = {
  dataSource: undefined,
  isIncludingVat: true,
  isVatShifted: false,
};

export default ItemsList;
